// removed by extract-text-webpack-plugin
module.exports = {"primaryColorBase":"#1E3282","primaryColorLight":"#273d92","primaryColorLighter":"#4860be","primaryColorLightest":"#8593ce"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/ReCarousel/CarouselAssets/CarouselAssets.scss
// module id = 36
// module chunks = 0